// Sends error notifications to the team Telegram bot.
// Uses fetch (not axios) so failures here never loop back through the axios interceptors.
const URL = process.env.REACT_APP_TELEGRAM_NOTIFY_URL;
const PROJECT = process.env.REACT_APP_TELEGRAM_PROJECT_NAME;
const KEY = process.env.REACT_APP_TELEGRAM_NOTIFY_KEY;

// Skip duplicate messages sent within this window, so one bug does not flood the chat
const DEDUPE_MS = 60 * 1000;
const recent = new Map();

export const notifyTelegram = (message, type = "danger") => {
  if (!URL || !KEY || !PROJECT) return;
  if (window.location.hostname === "localhost") return;

  const now = Date.now();
  if (recent.has(message) && now - recent.get(message) < DEDUPE_MS) return;
  recent.set(message, now);

  const text = `${message}\nPage: ${window.location.href}\nTime: ${new Date().toISOString()}`;
  fetch(URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ projectName: PROJECT, message: text.slice(0, 3500), type, key: KEY }),
  }).catch(() => {});
};

export const initGlobalErrorNotifier = () => {
  window.addEventListener("error", (e) => {
    notifyTelegram(`JS Error: ${e.message}\n${e.filename || ""}:${e.lineno || ""}`);
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    // API errors are already reported by the axios interceptor
    if (reason && reason.isAxiosError) return;
    notifyTelegram(`Unhandled Promise: ${reason?.message || String(reason)}`);
  });
};
